import { getProjectIdInfo } from 'owa-timestream-store';
import { isGuid } from 'owa-guid';
import type { ProjectId } from 'owa-timestream-types';
import getGroupSets from 'owa-session-store/lib/utils/getGroupSets';

const oidToSmtpMap = new Map<string, string>();

export default function getTargetMailbox(projectId: ProjectId) {
    const { tenant, mailbox } = getProjectIdInfo(projectId);
    if (isGuid(tenant) && isGuid(mailbox)) {
        // Assuming this is a group from Teams and that user belongs to the team
        // by the time MOCA is opened. If this is not valid in all cases we'll need
        // to resolve the group smtp address on the fly, maybe calling getUserUnifiedGroupsOperation
        // See owa-timestream-projectlocationpicker\lib\components\useUnifiedGroupList.tsx
        // Also consider reusing the groupStore from owa-groups-shared-store\lib\GroupsStore.ts
        // We might also want to subscribe to group association notifications to refresh this list.
        // See https://outlookweb.visualstudio.com/Outlook%20Web/_git/client-web/pullrequest/30468
        if (oidToSmtpMap.size == 0) {
            getGroupSets()?.UnifiedGroupsSets?.forEach(groupSet => {
                groupSet?.Groups?.forEach(group => {
                    if (group.ExternalDirectoryObjectId && group.SmtpAddress) {
                        oidToSmtpMap.set(group.ExternalDirectoryObjectId, group.SmtpAddress);
                    }
                });
            });
        }

        const smtp = oidToSmtpMap.get(mailbox);
        if (smtp) {
            return smtp;
        }
    }

    return tenant && mailbox ? `${mailbox}@${tenant}` : '';
}
